import React from "react";
import PlatformSessionPanel from "./PlatformSessionPanel";

// Platform metrics remain in the existing extension-backed hub widgets.
export default function OnlyFansLiveStats() {
  return <PlatformSessionPanel platform="onlyfans" />;
}
